import React, { useState } from "react";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";

const GOOGLE_MAPS_API_KEY = "YOUR_API_KEY_HERE";

function AddressPicker({ onAddressChange }) {
  const [address, setAddress] = useState("");
  const [coordinates, setCoordinates] = useState({ lat: null, lng: null });

  const handleSelect = async (value) => {
    try {
      setAddress(value);
      const address = value;
      const results = await geocodeByAddress(value);
      const latLng = await getLatLng(results[0]);
      const data = getCityStateCountryFromAddressResult(results[0]);
      console.log(data, "dataaz");
      setCoordinates(latLng);
      console.log("Selected coordinates:", latLng);
      onAddressChange?.({
        latitude: latLng?.lat,
        longitude: latLng?.lng,
        city: data.city,
        area: data.city,
        address,
      });
    } catch (error) {
      console.error("Error fetching geocode:", error);
    }
  };

  const getCityStateCountryFromAddressResult = (
    result: any
  ): { city: string; state: string; country: string } => {
    let city = "",
      state = "",
      country = "";
    for (let i = 0; i < result.address_components.length; i++) {
      for (let j = 0; j < result.address_components[i].types.length; j++) {
        switch (result.address_components[i].types[j]) {
          case "locality":
            city = result.address_components[i].long_name;
            break;
          case "administrative_area_level_1":
            state = result.address_components[i].long_name;
            break;
          case "country":
            country = result.address_components[i].long_name;
            break;
        }
      }
    }
    return { city, state, country };
  };
  console.log(address, "addressaddress");
  return (
    <div style={{ maxWidth: "50%", fontFamily: "Arial", marginBottom: 30 }}>
      <h2>Select Address</h2>
      <PlacesAutocomplete
        value={address}
        onChange={setAddress}
        onSelect={handleSelect}
      >
        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
          <div>
            <input
              {...getInputProps({
                placeholder: "Type address...",
                className: "location-search-input",
                style: {
                  width: "100%",
                  padding: "10px",
                  fontSize: "16px",
                },
              })}
            />
            <div style={{ border: "1px solid #ddd", borderTop: "none" }}>
              {loading && <div style={{ padding: "10px" }}>Loading...</div>}
              {suggestions.map((suggestion) => {
                const style = {
                  backgroundColor: suggestion.active ? "#f0f0f0" : "#fff",
                  cursor: "pointer",
                  padding: "10px",
                  borderBottom: "1px solid #ddd",
                };
                return (
                  <div
                    key={suggestion.placeId}
                    {...getSuggestionItemProps(suggestion, { style })}
                  >
                    {suggestion.description}
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </PlacesAutocomplete>

      {/* {coordinates.lat && coordinates.lng && (
        <div style={{ marginTop: "20px" }}>
          <h3>Selected Coordinates</h3>
          <p>Latitude: {coordinates.lat}</p>
          <p>Longitude: {coordinates.lng}</p>
        </div>
      )} */}
    </div>
  );
}

export default AddressPicker;
